export type AuthMethod = 'email' | 'whatsapp' | null;

export type AuthStep = 'phone_input' | 'verify_otp' | 'name_input' | 'email_input' | 'email_capture';

export interface AuthState {
  method: AuthMethod;
  step: AuthStep;
  email?: string;
  phone?: string;
  name?: string;
  tokenHash?: string;
}

export type AuthAction =
  | { type: 'SET_METHOD'; method: AuthMethod }
  | { type: 'SUBMIT_NAME'; name: string }
  | { type: 'SENT_OTP'; phone?: string; email?: string }
  | { type: 'OTP_VERIFIED'; tokenHash?: string; needsName: boolean }
  | { type: 'SHOW_NAME_INPUT' }
  | { type: 'SHOW_EMAIL_CAPTURE' }
  | { type: 'BACK' }
  | { type: 'RESET' };

export const initialState: AuthState = {
  method: 'whatsapp',
  step: 'phone_input',
};

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'SET_METHOD':
      return {
        ...initialState,
        method: action.method,
        step: action.method === 'email' ? 'email_input' : 'phone_input',
      };

    case 'SUBMIT_NAME':
      return { ...state, name: action.name };

    case 'SENT_OTP':
      return {
        ...state,
        phone: action.phone ?? state.phone,
        email: action.email ?? state.email,
        method: action.email ? 'email' : action.phone ? 'whatsapp' : state.method,
        step: 'verify_otp',
      };

    case 'OTP_VERIFIED':
      return {
        ...state,
        tokenHash: action.tokenHash,
        step: action.needsName ? 'name_input' : state.step,
      };

    case 'SHOW_NAME_INPUT':
      return { ...state, step: 'name_input' };

    case 'SHOW_EMAIL_CAPTURE':
      return { ...state, step: 'email_capture' };

    case 'BACK':
      return {
        ...state,
        step: state.method === 'email' ? 'email_input' : 'phone_input',
        phone: undefined,
        email: undefined,
        tokenHash: undefined,
      };

    case 'RESET':
      return initialState;

    default:
      return state;
  }
}
